/**
 * COLUMN SIZES
 */
import { ApprovalState } from '../../../../api/generated/data-contracts';

export const ROW_HEIGHT = 50;
export const ROW_EXPANDED_HEIGHT = 75;
export const ROW_STICKY_COUNT = 1;
export const TOP_HEADERS_HEIGHT = 50;

export const APPROVAL_STATES: ApprovalState[] = ['Pending', 'Approved', 'Rejected'];

export const CUSTOM_RATE_ID = 'ca1d89fb-1bfa-4b5b-9cc3-10428fe0d4d6';
